import { cn } from "@/lib/utils";
import agesIcon32 from "@/assets/ages-icon-32.png";
import agesIcon64 from "@/assets/ages-icon-64.png";
import agesIcon128 from "@/assets/ages-icon-128.png";

type Props = {
  className?: string;
  /** Pixel size of the icon (square). */
  size?: number;
  /**
   * Show the "AGES" wordmark next to the icon.
   * Default true — the icon is a textless mark, so most placements pair it with the wordmark.
   */
  withWordmark?: boolean;
};

/**
 * Official AGES brand mark — clean swirl emblem, optionally paired
 * with the gradient "AGES" wordmark.
 */
export const AgesLogo = ({ className, size = 32, withWordmark = true }: Props) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img
        src={agesIcon32}
        srcSet={`${agesIcon32} 1x, ${agesIcon64} 2x, ${agesIcon128} 4x`}
        alt="AGES brand mark"
        width={size}
        height={size}
        loading="lazy"
        decoding="async"
        className="object-contain"
        style={{ width: size, height: size }}
      />
      {withWordmark && (
        <span className="text-xl font-bold tracking-tight text-gradient-wealth">
          AGES
        </span>
      )}
    </div>
  );
};
